import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Spontanansokan = lazy(() => import("@/pages/info/Spontanansokan"));

export const Route = createFileRoute("/spontanansokan")({
  head: () => seoHead("/spontanansokan", { description: "Vi har inte alltid lediga tjänster utannonserade. Skicka in en spontanansökan så hör vi av oss när rätt roll dyker upp." }),
  component: () => <Spontanansokan />,
});
